export const useWholesalerItemsStore = defineStore('wholesalerItems', () => {
  const catalogApi = useCatalogAPI();
  const settingsStore = useSettingsStore();

  const wholesalerItems = ref<SearchItemResponse>();
  const onlyOwnItems = ref<SearchItemResponse>();

  async function fetchWholesalerItems(request: AppIonicSearchItemRequestDTO, isOwnItems: boolean) {
    const includeImages = request.OwnItemsOnly ? settingsStore._settings.showOwnItemImages : settingsStore._settings.showWholesalerCatalogItemImages;
    const wholesalerItemsResponse = await catalogApi.fetchWholesalerItemByElasticSearch(request, includeImages);

    if (!isOwnItems) {
      if (wholesalerItemsResponse && !wholesalerItemsResponse.HasErrors) {
        wholesalerItems.value = wholesalerItemsResponse.Data;
      }
    }

    if (isOwnItems) {
      if (wholesalerItemsResponse && !wholesalerItemsResponse.HasErrors) {
        onlyOwnItems.value = wholesalerItemsResponse.Data;
      }
    }
  }

  function reset() {
    wholesalerItems.value = undefined;
    onlyOwnItems.value = undefined;
  }

  const wholesalerItemsAsMaterialItemApp = computed(() => wholesalerItems.value?.SearchItems ?? []);

  const ownItemsAsMaterialItemApp = computed(() => onlyOwnItems.value?.SearchItems ?? []);

  return {
    _wholesalerItems: wholesalerItems,
    wholesalerItems: readonly(wholesalerItems),
    _onlyOwnItems: onlyOwnItems,
    onlyOwnItems: readonly(onlyOwnItems),
    fetchWholesalerItems,
    reset,
    wholesalerItemsAsMaterialItemApp: wholesalerItemsAsMaterialItemApp,
    ownItemsAsMaterialItemApp: ownItemsAsMaterialItemApp
  };
});
